module.exports = __webpack_public_path__ + "stripe-logo.7b46e9959127e1d68153203d10927972.svg";